/* eslint-disable import/prefer-default-export */
import * as api from '../../api';
import * as types from '../action.types';
import { executeRules } from './rule.actions';
import { addMessage } from './message.actions';

const addMappingRequest = () => ({
  type: types.FETCH_MAPPING_REQUEST,
});

const addMappingSuccess = data => ({
  type: types.FETCH_MAPPING_SUCCESS,
  payload: data,
});

const addMappingError = () => ({
  type: types.FETCH_MAPPING_ERROR,
});

export const deleteMappingItem = key => ({
  type: types.DELETE_MAPPING_ITEM,
  payload: key,
});

export const deleteMetadataItem = key => ({
  type: types.DELETE_METADATA_ITEM,
  payload: key,
});

export const clearMapping = () => ({
  type: types.CLEAR_MAPPING,
});

export const setMetadataType = (key, type = 'User') => ({
  type: types.SET_METADATA_TYPE,
  payload: {
    key,
    type,
  },
});

export const setMetadataFormat = (key, format = '') => ({
  type: types.SET_METADATA_FORMAT,
  payload: {
    key,
    format,
  },
});

export const setMetadataFieldType = (key, fieldType = '') => ({
  type: types.SET_METADATA_FIELD_TYPE,
  payload: {
    key,
    fieldType,
  },
});

const createNewMetadata = (filename, name, columns, separator, sync) => ({
  type: types.CREATE_NEW_METADATA,
  payload: {
    filename,
    name,
    columns,
    separator,
    sync,
  },
});

export const setTargetValue = (key, name) => ({
  type: types.SET_TARGET_VALUE,
  payload: {
    key,
    name,
  },
});

export function updateMetadataOrder(metadataArray) {
  const metadataArrayUpdatedIndexes = metadataArray.map((column, index) => ({
    ...column,
    index,
  }));

  return {
    type: types.UPDATE_METADATA_ORDER,
    payload: metadataArrayUpdatedIndexes,
  };
}

export function fetchParsedMappingFile(file, callback = () => null) {
  return (dispatch) => {
    dispatch(addMappingRequest());

    return api.fetchParsedMappingFile(file)
      .then((data) => {
        dispatch(addMappingSuccess(data));
        callback();
      })
      .catch(({ message }) => {
        dispatch(addMessage('error', message));
        dispatch(addMappingError());
      });
  };
}

export function createNewMetadataAndExecuteRules(name, columns, separator, sync) {
  return (dispatch, getState) => {
    const { currentSessionId, currentFileId } = getState().status;
    const { filename } = getState().sessions[currentSessionId].files[currentFileId];

    dispatch(createNewMetadata(filename, name, columns, separator, sync));
    dispatch(executeRules());
  };
}
